'use client';

import { c as _c } from "react/compiler-runtime";
import { UserLoginLink } from 'design-system/client';
import { usePathname } from 'next/navigation';
import TextLink from '../TextLink';
import { RailsRoutes } from '@/helpers/utils';
import getPublicUrl from '@/helpers/utils/routing/getPublicUrl';
import { useLocale } from '@/i18n/client';
function LoginButton(t0) {
  const $ = _c(7);
  const {
    children: label
  } = t0;
  const pathname = usePathname();
  const locale = useLocale();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getPublicUrl();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const nextPublicUrl = t1;
  const returnToUrl = `${nextPublicUrl !== process.env.NEXT_PUBLIC_BETTERPLACE_URL ? nextPublicUrl : ""}${pathname}`;
  let t2;
  if ($[1] !== locale || $[2] !== returnToUrl) {
    t2 = RailsRoutes.signIn({
      return_to: returnToUrl,
      locale: locale ?? "de"
    });
    $[1] = locale;
    $[2] = returnToUrl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const loginUrl = t2;
  let t3;
  if ($[4] !== label || $[5] !== loginUrl) {
    t3 = <UserLoginLink Link={TextLink} text={{
      loginUrl,
      label
    }} />;
    $[4] = label;
    $[5] = loginUrl;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}
export default LoginButton;